/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

const STATUT_PACS = [
  {
    key: 1,
    text: 'En cours',
    value: 1,
  },
  {
    key: 2,
    text: 'Irrecevable',
    value: 2,
  },
];

export default STATUT_PACS;
